// style
import './style/home.css'
// link
import { useNavigate, useParams } from "react-router-dom";
// hook
import { useEffect, useState } from "react";
// split number
import { splitNumber } from "../../../features/splitNumber/splitNumber";
// make query
import { sendPaymentInfo } from "../../../services/charge/charge";
import { useMutation } from "@tanstack/react-query";
// component
import Loading from "../../../components/loading/loading";
// cookie
// @ts-ignore
import Cookies from 'js-cookie';
// layouts
import { sendPaymentInfo2 } from '../../../services/charge/charge2';
import { fetchSepShareTokenFlowUSSD } from '../../../services/auth/sepTokenGeneral';

const HomePayment2 = () => {
    const navigate = useNavigate();
    const { id, key }: any = useParams();
    const [user, setUser] = useState<any>();
    const [status, setStatus] = useState<boolean>(false);

    // وضعیت‌های دریافت توکن هنگام کلیک دکمه پرداخت
    const [sepTokenLoading, setSepTokenLoading] = useState<boolean>(false);
    const [sepTokenError, setSepTokenError] = useState<string | null>(null);

    const handleCommonSuccess = (data: any) => {
        if (data) {
            setUser(data);
            // @ts-ignore
            if (data?.isWallet === false) {
                setStatus(true);
            } else {
                setStatus(false);
            }
            Cookies.set('userData', JSON.stringify(data), { expires: 7 });
        } else {
            navigate('/error/message');
        }
    };

    const mutation = useMutation({
        mutationFn: sendPaymentInfo,
        onSuccess: handleCommonSuccess,
        onError: () => {
            navigate('/error/message');
        },
    });

    const mutation_2 = useMutation({
        mutationFn: sendPaymentInfo2,
        onSuccess: handleCommonSuccess,
        onError: () => {
            navigate('/error/message');
        },
    });

    useEffect(() => {
        document.getElementById('site-main')?.classList.remove('main-content');
        document.getElementById('site-main')?.classList.add('bg-payment-new');
        document.getElementById('site-main')?.classList.add('bg-payment-new-home');
        document.getElementById('site-main')?.classList.add('bg-white');

        if (key === "general") {
            mutation_2.mutate(id);
        } else {
            mutation.mutate(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, key]);

    // تابع ارسال مستقیم فرم POST به درگاه شاپرک سپ
    const submitToSepGateway = (token: string) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = 'https://sep.shaparak.ir/OnlinePG/OnlinePG';

        const tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'Token';
        tokenInput.value = token;
        form.appendChild(tokenInput);

        const getMethodInput = document.createElement('input');
        getMethodInput.type = 'hidden';
        getMethodInput.name = 'GetMethod';
        getMethodInput.value = '';
        form.appendChild(getMethodInput);

        document.body.appendChild(form);
        form.submit();
    };

    // کلیک روی دکمه پرداخت: دریافت توکن و سپس ریدایرکت
    const handlePaymentSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSepTokenError(null);

        const resNum = user?.resNum;
        if (!resNum) {
            if (user?.externalCode) {
                submitToSepGateway(user.externalCode);
                return;
            }
            setSepTokenError('شماره پیگیری تراکنش موجود نیست');
            return;
        }

        setSepTokenLoading(true);
        try {
            const { sepData } = await fetchSepShareTokenFlowUSSD(resNum);
            const token = sepData?.data ?? user?.externalCode;

            if (token) {
                submitToSepGateway(token);
            } else {
                setSepTokenError('خطا در دریافت توکن از درگاه پرداخت');
            }
        } catch (err: any) {
            setSepTokenError(err?.message || 'خطا در دریافت توکن پرداخت');
        } finally {
            setSepTokenLoading(false);
        }
    };

    // وضعیت لودینگ اولیه برای لود داده‌های اولیه صفحه
    const isPageLoading = mutation.isPending || mutation_2.isPending || !user;

    return (
        <>
            <article className={'payment overflow-x-hidden'}>
                <div className="row justify-content-center h-100">
                    <header className={'container text-center'}>
                        <div className="top-bar" style={{ paddingBottom: '15px' }}>
                            <div className="d-flex justify-content-center">
                                <img alt="logo" src={require('./../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                            </div>
                            <p className="text-white text-center mb-5 fw-bold">
                                سامانه ملی امن, سریع و آسان تراکنش ایران
                            </p>
                        </div>
                    </header>
                    <div className="col-lg-4 col-md-6">
                        {isPageLoading ? (
                            <div className="d-flex justify-content-center align-items-center py-5">
                                <Loading />
                            </div>
                        ) : (
                            <>
                                <section style={{ marginTop: '-40px' }} className={'profile container'}>
                                    <div className={'profile-items d-flex justify-content-center text-center'}>
                                        {status ? (
                                            user?.image ? (
                                                <img alt='profile' className={'profile-img-valid'} src={user.image} />
                                            ) : (
                                                <img
                                                    alt='profile'
                                                    className='profile-img-valid'
                                                    src={require('./../../../assets/media/images/payment/Profile_Vr_01 1.png')}
                                                />
                                            )
                                        ) : (
                                            <h5 className={'text-white text-center mt-1 fw-bold'}>
                                                شارژ حساب کاربری ایران تراکنش
                                            </h5>
                                        )}
                                    </div>
                                    {status && (
                                        <p className={'fw-bold text-center mt-3 mb-1'}>
                                            <span className={'ms-1'}>
                                                {user?.firstName}
                                            </span>
                                            {user?.lastName}
                                        </p>
                                    )}
                                    <p className={'text-muted text-center mb-2'}>
                                        {status ? user?.merchantCode : `${user?.mobile}`}
                                    </p>
                                </section>

                                {status && (
                                    <section id={'endPoint'} className={'container text-center mt-2'}>
                                        <span className="badge bg-success-site mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                            مبلغ قابل پرداخت
                                        </span>
                                        <p className={'price dark-green card-text mt-3 h4 fw-bold'}>
                                            <span className={'price-amount ms-1'}>
                                                {splitNumber(user?.payablePrice / 10)}
                                            </span>
                                            تومان
                                        </p>
                                    </section>
                                )}

                                {!status && (
                                    <section id={'endPoint'} className={'container text-center mt-2'}>
                                        <span className="badge bg-success-site mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                            موجودی ایران تراکنشی شما قبل از پرداخت
                                        </span>
                                        <p className={'price dark-green card-text mt-3 h4 fw-bold'}>
                                            <span className={'price-amount ms-1'}>
                                                {splitNumber(user?.currentBalance / 10)}
                                            </span>
                                            تومان
                                        </p>
                                    </section>
                                )}

                                <div className='container-fluid'>
                                    <section className={'alert bg-success-site d-flex justify-content-between py-3 my-2 mt-3'}>
                                        <p className={'font-small fw-bold text-white fw-bold mb-0'}>
                                            {status ? 'برداشت از کارت بانکی شما با احتساب کارمزد' : 'مبلغ قابل پرداخت با احتساب کارمزد'}
                                        </p>
                                        <p className={'price font-small fw-bold text-white mb-0'}>
                                            <span className={'price-amount ms-1'}>
                                                {splitNumber(user?.price / 10)}
                                            </span>
                                            تومان
                                        </p>
                                    </section>
                                </div>

                                <div className='container-fluid'>
                                    <section className={'alert d-flex bg-success-site justify-content-between py-3 my-2 mt-3'}>
                                        <p className={'font-small fw-bold text-white fw-bold mb-0'}>
                                            {!status ? ' موجودی ایران تراکنشی شما بعد از پرداخت' : 'موجودی فعلی ایران تراکنشی شما'}
                                        </p>
                                        <p className={'price font-small fw-bold text-white mb-0'}>
                                            <span className={'price-amount ms-1'}>
                                                {!status ? (
                                                    splitNumber(((user?.price + user?.currentBalance) - user?.wage) / 10)
                                                ) : (
                                                    splitNumber(user?.currentBalance / 10)
                                                )}
                                            </span>
                                            تومان
                                        </p>
                                    </section>
                                </div>

                                <hr />

                                <section className={'action container w-100 my-1 mt-2'}>
                                    {sepTokenError && (
                                        <p className='text-danger text-center w-100 font-small mb-2'>{sepTokenError}</p>
                                    )}
                                    <form className='w-100 text-center' onSubmit={handlePaymentSubmit}>
                                        <button
                                            type="submit"
                                            disabled={sepTokenLoading}
                                            className={'btn btn-site w-100 px-5 mb-3 text-white d-flex align-items-center justify-content-center'}>
                                            {sepTokenLoading ? (
                                                <div className="spinner-border spinner-border-sm me-2" role="status" />
                                            ) : null}
                                            <span className={'card-text'}>
                                                {sepTokenLoading ? 'در حال انتقال به درگاه...' : 'تایید و پرداخت'}
                                            </span>
                                        </button>
                                        <span style={{ borderBottom: '1px solid #FFB72B' }} className={'font-small mt-3 rounded-3 mb-0 text-center'}>
                                            بدون نیاز به نصب اپلیکیشن
                                        </span>
                                    </form>
                                </section>
                            </>
                        )}
                    </div>
                </div>
            </article>
        </>
    );
};

export default HomePayment2;
